import React from 'react';
import PropTypes from 'prop-types';
import useModalClose from '../hooks/useModalClose';

const PersonelModal = ({ isOpen, onClose, userData }) => {
  const firstUser = userData?.records[0];
  useModalClose(isOpen, onClose);

  if (!firstUser) return null;

  // Format date string to display in a user-friendly format
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch (e) {
      return dateString;
    }
  };

  const expBadge = (description) => {
    switch(description) {
        case 'Projeye Katılmıyor':
        return <span className="badge red">Projeye Katılmıyor</span>;
        case 'Adres Yanlış/Hatalı/Eksik':
        return <span className="badge yellow">Adres Yanlış/Hatalı/Eksik</span>;
        case 'Açıklamayı Gör':
        return <span className="badge grey">Açıklamayı Gör</span>;
        default:
        return '-';
    }
  }

  if (userData.records.length === 0) return null;
  if (userData && firstUser) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content waste-detail-modal" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Detay</h3>
          </div>
          
          <div className="modal-body personel-modal-body">
            <div className="detail-section">
              <div className='personel-modal-row'>
                  <h4>Tarih ve Saat :</h4>
                  <p>{formatDate(firstUser.dateGiven)}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Personel Adı :</h4>
                  <p>{firstUser.personelAlinan}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>İlçe :</h4>
                  <p>{firstUser.ilce}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Mahalle :</h4>
                  <p>{firstUser.mahalle}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Sokak :</h4>
                  <p>{firstUser.sokak}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Apartman Adı ve Daire No :</h4>
                  <p>{firstUser.apartman} / {firstUser.daire}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Verilen Poşet Sayısı :</h4>
                  <p>{userData.verilenPosetSayisi > 0 ? `${userData.verilenPosetSayisi} Poşet` : '-'}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Alınan Atık Sayısı :</h4>
                  <p>{userData.alinanPosetSayisi > 0 ? `${userData.alinanPosetSayisi} Atık` : '-'}</p>
              </div>
              <div className='personel-modal-row'>
                  <h4>Açıklama :</h4>
                  <p>{expBadge(firstUser.description)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
};

PersonelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    date: PropTypes.string,
    name: PropTypes.string,
    surname: PropTypes.string,
    district: PropTypes.string,
    neighborhood: PropTypes.string,
    street: PropTypes.string,
    apartmentName: PropTypes.string,
    bagsGiven: PropTypes.number,
    wasteCollected: PropTypes.number,
    description: PropTypes.string
  })
};

export default PersonelModal; 